import { TbWeight } from "react-icons/tb";

import { WeighingPermission } from "@/weighing/models/WeighingPermission";

import { IGIREMenuItem } from "../../models/router.types";
import { PathNamekAppsRoutes } from "../../constants";

export const weighingMenuItems: IGIREMenuItem[] = [
  {
    label: "Pesaje",
    icon: <TbWeight size={18} />,
    data: PathNamekAppsRoutes.WEIGHING,
    permission: {
      must: [
        WeighingPermission.REVIEW,
        WeighingPermission.PRODUCTIVITY,
        WeighingPermission.DETAILED_PRODUCTIVITY,
      ],
      exhaustive: false,
    },
    items: [
      {
        label: "Reporte de productividad",
        url: `/#/${PathNamekAppsRoutes.WEIGHING}/reporte-productividad`,
        permission: {
          must: WeighingPermission.PRODUCTIVITY,
        },
      },
      {
        label: "Reporte detallado de productividad",
        url: `/#/${PathNamekAppsRoutes.WEIGHING}/reporte-detallado-productividad`,
        permission: {
          must: WeighingPermission.DETAILED_PRODUCTIVITY,
        },
      },
      {
        label: "Revisión manual",
        url: `/#/${PathNamekAppsRoutes.WEIGHING}/revision-manual`,
        permission: {
          must: WeighingPermission.REVIEW,
        },
      },
    ],
  },
];
